import { AddonPriceComposition } from '@niarab2c/frontend-commons/src/types/addon';
import { NiaraIcon } from '@niaratech/niara-icons';
import { printPrice } from '@niaratech/niara-js-commons';
import { Tooltip } from '@niaratech/niara-react-components';
import { Addon } from 'niara-spear-crudmodel';
import React, { useState } from 'react';
import { getGuestsCountLabel } from '../utils';
import ModalOTA from '../../../components/ModalOTA';
import AddonCardDetails from '../../../Addon/AddonCardDetails';
import * as S from './styles';
export type GroupedPriceByVariant = Addon['priceByVariant'][number] & {
  quantity: number;
  showAges?: boolean;
};
export type AddonGroupedCartItem = {
  addon: Addon;
  scheduleDate?: string;
  scheduleTime?: string;
  variants: GroupedPriceByVariant[];
  totalPrice: AddonPriceComposition;
  onRemoveGroupedItems: () => void;
};
interface AddonCartItemProps {
  groupedCartItem: AddonGroupedCartItem;
}
const AddonCartItemV2: React.FC<AddonCartItemProps> = ({
  groupedCartItem
}) => {
  const addon = groupedCartItem?.addon;
  const [showAddonCardDetailsModal, setShowAddonCardDetailsModal] = useState(false);
  const onAddonClick = () => {
    setShowAddonCardDetailsModal(true);
  };
  return <S.AddonSection>
      <S.Container>
        <S.HeaderContainer>
          <S.AddonThumbnail src={addon?.images?.[0]?.url} alt={addon?.images?.[0]?.name} />

          <S.TitleContainer onClick={onAddonClick}>
            <S.AddonTitle isMandatoryPurchase={addon?.mandatoryPurchase}>{addon?.name}</S.AddonTitle>
            <S.AddonQuantity type={'text'}>
              {" Quantidade: "}
              <span className="addon-quantity">{getGuestsCountLabel(groupedCartItem?.variants, true)}</span>
            </S.AddonQuantity>
          </S.TitleContainer>
        </S.HeaderContainer>

        {!addon?.mandatoryPurchase && <S.BodyContainer>
            <Tooltip title={"Remover"} placement="top">
              <S.IconButton onClick={groupedCartItem?.onRemoveGroupedItems}>
                <NiaraIcon icon="sysDelete" size={16} />
              </S.IconButton>
            </Tooltip>
          </S.BodyContainer>}
      </S.Container>
      <S.PriceContainer>
        {addon?.mandatoryPurchase && addon?.shouldIncludeAddonInRate ? <S.AddonPrice>{"Incluído"}</S.AddonPrice> : !addon?.shouldIncludeAddonInRate && groupedCartItem?.totalPrice?.total?.value == 0 ? <S.AddonPrice>{"Grátis"}</S.AddonPrice> : <S.AddonPrice>
            {printPrice(groupedCartItem?.totalPrice?.total?.value, groupedCartItem?.totalPrice?.total?.currency)}
          </S.AddonPrice>}
      </S.PriceContainer>

      <ModalOTA show={showAddonCardDetailsModal} setShow={setShowAddonCardDetailsModal} mobileVariant="full" hideHeader showCloseButton padding="0" render={() => <AddonCardDetails showHeaderOnly addonResult={{
      addon,
      results: [addon]
    } as any} />} />
    </S.AddonSection>;
};
export default AddonCartItemV2;